import { render, staticRenderFns } from "./pie-data.vue?vue&type=template&id=6925d6b4&scoped=true"
import script from "./pie-data.vue?vue&type=script&lang=js"
export * from "./pie-data.vue?vue&type=script&lang=js"
import style0 from "./pie-data.vue?vue&type=style&index=0&id=6925d6b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6925d6b4",
  null
  
)

export default component.exports